window.context = {
  manage: '/mvue',//管理端页面
  front: '/fvue',//前端页面
  portal: '/portal',
  bpmRunTime: '/bpm-runtime',
  bpmModel: '/bpm-model',
  uc: '/uc',
  form: '/form'
};

// 单点配置
window.ssoConfig = {
  mode: "", // 空则不使用单点  支持的模式有  cas oauth basic
  url: '/oauth/authorize',
  clientId: 'eip7',// oauth模式下需要提供
  logout: '/logout'
}
